<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M24 4.00001H19.76C19.2 2.45334 17.7334 1.33334 16 1.33334C14.2667 1.33334 12.8 2.45334 12.24 4.00001H8.00004C6.53337 4.00001 5.33337 5.20001 5.33337 6.66668V26.6667C5.33337 28.1333 6.53337 29.3333 8.00004 29.3333H16.1467C15.36 28.5733 14.72 27.6667 14.2534 26.6667H8.00004V6.66668H10.6667V10.6667H21.3334V6.66668H24V13.44C24.9467 13.5733 25.84 13.8533 26.6667 14.24V6.66668C26.6667 5.20001 25.4667 4.00001 24 4.00001ZM16 6.66668C15.2667 6.66668 14.6667 6.06668 14.6667 5.33334C14.6667 4.60001 15.2667 4.00001 16 4.00001C16.7334 4.00001 17.3334 4.60001 17.3334 5.33334C17.3334 6.06668 16.7334 6.66668 16 6.66668Z" fill="#071689"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.6667 16C18.9867 16 16 18.9867 16 22.6667C16 26.3467 18.9867 29.3333 22.6667 29.3333C26.3467 29.3333 29.3333 26.3467 29.3333 22.6667C29.3333 18.9867 26.3467 16 22.6667 16ZM24.8667 25.8L22 22.9333V18.6667H23.3333V22.3867L25.8 24.8533L24.8667 25.8Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "ExpectedOrderIcon",

    props: {
        width: {
            type: Number,
            default: 32
        },

        height: {
            type: Number,
            default: 32
        },

        classes: {
            type: String
        }
    }
}
</script>